import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children, defaultTheme = "light", forceScope }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem("titan_theme") || defaultTheme);

  useEffect(() => {
    const scope = forceScope || theme;
    const root = document.documentElement;
    if (scope === "dark") root.classList.add("dark"); else root.classList.remove("dark");
    localStorage.setItem("titan_theme", theme);
  }, [theme, forceScope]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle: () => setTheme(t => t === "dark" ? "light" : "dark") }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext) || { theme: "light", setTheme: () => {} };
